// dropdown-menu.jsx
import React, { useState } from "react";

export default function DropdownMenu({ buttonContent, children }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  return (
    <div className="relative inline-block text-left">
      <button
        onClick={toggleMenu}
        className="bg-surface text-body px-4 py-2 rounded-xl hover:bg-accent-1/20 border border-border transition"
      >
        {buttonContent}
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 rounded-xl shadow-lg bg-surface border border-border z-50 transition-all duration-200 ease-out origin-top transform">
          {typeof children === "function" ? children({ closeMenu }) : children}
        </div>
      )}
    </div>
  );
}
